import { HttpResponse } from 'msw';

import { genDoctor } from '@/shared/lib/msw/generators/doctor';
import { genMedcenterSchedule } from '@/shared/lib/msw/generators/medcenter';

import { doctorAliases } from '../schedule';

export const getDoctor = () => {
  return HttpResponse.json(
    {
      data: genDoctor({
        data: {
          medcenterData: {
            id: 139835,
            hasOnlineBooking: true,
            hasPhones: true,
            schedule: genMedcenterSchedule({
              is24HoursWork: 'none',
              isWork: [1, 2, 3, 4, 5, 6],
            }),
          },
          doctorData: {
            id: 1487,
            isPartner: true,
            fullName: 'тестовый олег',
            alias: doctorAliases.base,
          },
        },
      }),
    },
    { status: 200 },
  );
};

export const getDoctorWithEmptySchedule = () => {
  return HttpResponse.json(
    {
      data: genDoctor({
        data: {
          medcenterData: {
            id: 139577,
            hasOnlineBooking: false,
            hasPhones: true,
            schedule: [],
          },
          doctorData: {
            id: 30007,
            isPartner: true,
            fullName: 'тестовый Надыр',
            alias: doctorAliases.emptySchedule,
          },
        },
      }),
    },
    { status: 200 },
  );
};

export const getDoctorWithMedelementEmptySlots = () => {
  return HttpResponse.json(
    {
      data: genDoctor({
        data: {
          medcenterData: {
            id: 28,
            hasOnlineBooking: true,
            hasPhones: true,
            schedule: genMedcenterSchedule({
              is24HoursWork: 'none',
              isWork: [6],
            }),
          },
          doctorData: {
            id: 3204,
            isPartner: true,
            fullName: 'тестовый Нурлан',
            alias: doctorAliases.emptySlotsWithMedelement,
          },
        },
      }),
    },
    { status: 200 },
  );
};
